

import React, { memo, useMemo } from 'react';


import { ADDON_TYPE } from '@shootsta/common-domain-data';
import CaptionAddonView from '../CaptionAddonView';
import CommonAddonView from '../CommonAddonView';
import SupersizeMyEditAddonView from '../SupersizeMyEditAddonView';
import AdditionalOutputAddonView from '../AdditionalOutputAddonView';
import { getAddonType } from '../../../../common/utils';
import '../../styles/_addons-list.scss';
import GroupedAddonList from './components/GroupedAddonList';






















const getAddonComponentByType = (params) => {
  const { addonType } = params;

  switch (addonType) {
    case ADDON_TYPE.SRT_CAPTIONS:
    case ADDON_TYPE.BURN_IN_CAPTIONS:{
        return <CaptionAddonView {...params} />;
      }
    case ADDON_TYPE.SUPERSIZE_MY_EDIT:{
        return <SupersizeMyEditAddonView {...params} />;
      }
    case ADDON_TYPE.ADDITIONAL_OUTPUT:{
        return <AdditionalOutputAddonView {...params} />;
      }
    default:{
        return <CommonAddonView {...params} />;
      }
  }
};

function BasicAddonsList({
  addonsList = [],
  noAddonsMessage,
  isAddonDescriptionWrapped,
  onChangeAddonStatus,
  shouldShowActions,
  isNewDesign,
  getAdditionalOutputs,
  getCaptions,
  getFormattedAddon
}) {
  if (isNewDesign) {
    return (
      <GroupedAddonList
        addonsList={addonsList}
        getAdditionalOutputs={getAdditionalOutputs}
        getCaptions={getCaptions}
        getFormattedAddon={getFormattedAddon}
        shouldShowActions={shouldShowActions}
        onChangeAddonStatus={onChangeAddonStatus}
        isAddonDescriptionWrapped={isAddonDescriptionWrapped} />);


  }

  const renderAddons = () => addonsList.map((addon, i) => {
    const addonType = getAddonType(addon);
    return getAddonComponentByType({
      key: i,
      addonType,
      addon: addon[addonType],
      isAddonDescriptionWrapped,
      shouldShowActions,
      onChangeAddonStatus,
      aspectRatio: addon[addonType].aspectRatio,
      isNewDesign
    });
  });

  const addons = useMemo(
    () => renderAddons(),
    [addonsList, isAddonDescriptionWrapped, shouldShowActions, onChangeAddonStatus]
  );

  return (
    <div className="addons-list">
      <div className="addons-list__body">
        <div className="addons-list__body-list">
          {
          addonsList?.length ?
          addons :
          noAddonsMessage}

        </div>
      </div>
    </div>);

}

export default memo(BasicAddonsList);